import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory, useParams, withRouter } from 'react-router-dom'
import { tasksApi } from '../../../../api/tasksApi'
import { routes } from '../../../../constantes/routes'
import TasksFrom from '../TasksForm'
import Header from '../../../header/Header'
import { businessunitsActions } from '../../../../actions/businessunitsActions'
import { hospitalsActions } from '../../../../actions/hospitalsActions'
import { specialtiesActions } from '../../../../actions/specialtiesActions'
import { eventosActions } from '../../../../actions/eventosActions'

const EditTaskContainer = () => {
  const { id } = useParams()
  const history = useHistory()

  const contacts = useSelector((state) => state.contacts)
  const events = useSelector((state) => state.events)
  const phases = useSelector((state) => state.phases)
  const businessunits = useSelector((state) => state.businessunits)
  const hospitals = useSelector((state) => state.hospitals || [])
  const specialties = useSelector((state) => state.specialties || [])
  const eventos = useSelector((state) => state.eventos || [])
  const userProfile = useSelector((state) => state.userProfile)

  const dispatch = useDispatch()
  const getAllBusinessUnits = () =>
    dispatch(businessunitsActions.getAllBusinessUnits())
  const getAllHospitals = () => dispatch(hospitalsActions.getAllHospitals())
  const getAllSpecialties = () =>
    dispatch(specialtiesActions.getAllSpecialties())
  const getAllEventos = () => dispatch(eventosActions.getAllEventos())

  const [inputs, setinputs] = useState({
    id_CRM: id,
    id_Usuario: '',
    id_Contacto: '',
    id_TipoFase: '',
    id_TipoAsunto: '',
    asunto: '',
    fecha: '',
    descripcion: '',
    isVerCaledario: '',
    FechaProximoContacto: '',
    id_NegocioUnidades: [],
    id_Evento: '',
    hospitales: '',
    especialidades: '',
    businessUnits: [], // Mantener para compatibilidad
  })

  useEffect(() => {
    getTaskById(id)
    getAllBusinessUnits()
    getAllHospitals()
    getAllSpecialties()
    getAllEventos()
  }, [id])

  const getTaskById = async (idTask) => {
    try {
      const response = await tasksApi.getTasksById(idTask)


      // Transformar id_NegocioUnidades a businessUnits para el frontend (compatibilidad)
      const businessUnits = response.data.id_NegocioUnidades
        ? businessunits.filter((bu) =>
            response.data.id_NegocioUnidades.includes(bu.id_NegocioUnidad),
          )
        : []

      // Actualizar todos los campos incluyendo los nuevos
      setinputs({
        id_CRM: response.data.id_CRM || id,
        id_Usuario: response.data.id_Usuario || '',
        id_Contacto: response.data.id_Contacto || '',
        id_TipoFase: response.data.id_TipoFase || '',
        id_TipoAsunto: response.data.id_TipoAsunto || '',
        asunto: response.data.asunto || '',
        fecha: response.data.fecha || '',
        descripcion: response.data.descripcion || '',
        isVerCaledario: response.data.isVerCaledario || '',
        FechaProximoContacto: response.data.FechaProximoContacto || '',
        id_NegocioUnidades: response.data.id_NegocioUnidades || [],
        id_Evento: response.data.id_Evento || '',
        hospitales: response.data.hospitales || '',
        especialidades: response.data.especialidades || '',
        businessUnits: businessUnits, // Mantener para compatibilidad
      })
    } catch (error) {
      console.error('Error fetching task:', error)
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        alert(error.response.data.message)
      } else if (error.response && error.response.data) {
        alert(error.response.data)
      } else {
        alert('Error al cargar la tarea')
      }
    }
  }

  const toManagement = () => {
    history.push(routes.MANAGEMENT)
  }

  return (
    <>
      {
        <div className='history-wrap'>
          <div className='products'>
            <Header text={''} route={toManagement} backBtn={true} />
            <TasksFrom
              inputs={inputs}
              contacts={contacts}
              events={events}
              phases={phases}
              businessunits={businessunits}
              hospitals={hospitals}
              specialties={specialties}
              eventos={eventos}
              isDisable={false}
              handleSubmit={false}
              handleChange={false}
              readOnly={true}
            />
          </div>
        </div>
      }
    </>
  )
}
export default withRouter(EditTaskContainer)
